import { RepositoryFactory } from '../../RepositoryFactory';
import Vue from 'vue';
const campaigns = new RepositoryFactory('campaign');

export default {
  namespaced: true,
  state: {
    // Single Campaign
    campaign: {
      id: null,
      name: '',
      type: '',
    },
    campaigns: [],

    // Pagination Params
    currentPage: 1,
    total: 0,
    totalPages: 0,
    itemCount: 0,

    // Actions States
    loading: false,
    error: false,
  },
  getters: {
    getCampaign(state) {
      return state.campaign;
    },
    get(state) {
      for (const iterator of state.campaigns) {
        const date = new Date(iterator.createdAt);
        iterator.createdAt = date.toLocaleDateString('pt-BR');
      }

      return state.campaigns.map(s => ({
        id: s.id,
        name: s.name,
        createdAt: s.createdAt,
        type: s.type,
      }));
    },
    getCampaignsTableData(state) {
      return {
        error: state.error,
        loading: state.loading,
        currentPage: state.currentPage,
        totalPages: state.totalPages,
        itemCount: state.itemCount,
        total: state.total,
      };
    },
  },
  mutations: {
    SET_CAMPAIGN(state, data) {
      state.campaign = data;
    },
    SET_CAMPAIGNS(state, data) {
      state.campaigns = data.items;
      state.total = data.totalItems;
      state.itemCount = data.itemCount;
      state.totalPages = data.pageCount;
    },
    SET_PAGE(state, page) {
      state.currentPage = page;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
  },
  actions: {
    setPage: async ({ commit, dispatch }, page) => {
      commit('SET_PAGE', page);
      dispatch('get');
    },
    update: async ({ dispatch }, payload) => {
      try {
        await classes.update(payload.id, payload.params);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Classe atualizada com sucesso!',
        });
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: error.response.data.message,
        });
      }
      dispatch('getClasses');
    },
    create: async ({ commit, dispatch }, payload) => {
      try {
        await campaigns.create(payload);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Campanha criada com sucesso!',
        });
        dispatch('get');
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: error.response.data.message,
        });
      }
    },
    getCampaignById: async ({ commit }, id) => {
      try {
        const { data } = await campaigns.getById(id);
        commit('SET_CAMPAIGN', data);
      } catch (error) {}
    },
    get: async ({ state, commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await campaigns.get(state.currentPage);
        commit('SET_CAMPAIGNS', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
    searchClass: async ({ commit }, search) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await classes.getWithSearch(search);
        commit('SET_CLASSES', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
  },
};
